import { MAX_CHARACTER_COUNT } from '~/constants/config'

const useMaxCharacterCount = (count: number) => {
  const hasExceededMaxCount = count > (MAX_CHARACTER_COUNT as number)

  return { hasExceededMaxCount, count }
}

export default useMaxCharacterCount
